
import { computed, defineComponent, ref, watch } from "vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

import ApiService from "@/core/services/ApiService";
import { DrawerComponent } from "@/assets/ts/components/_DrawerComponent";

export default defineComponent({
  name: "update_api_drawer",
  emit: ["submit"],
  props: {
    api: Object,
    procs: {
      type: Array,
      required: true,
    },
  },
  setup(props, { emit }) {
    const submitButton = ref<HTMLButtonElement | null>(null);

    const alias_name = ref("");

    const parameters = computed(() => {
      if (props.api && props.api.parameters) {
        return JSON.parse(props.api.parameters);
      }

      return {};
    });

    const isShowWarning = ref(false);
    const procsData = ref<unknown[]>([]);
    watch(
      () => props.procs,
      () => {
        procsData.value = props.procs;
        if (procsData.value.length === 0) {
          isShowWarning.value = true;
        }
      }
    );

    watch(
      () => props.api,
      () => {
        if (props.api) {
          alias_name.value = props.api.alias_name;
        } else {
          alias_name.value = "";
        }
      }
    );

    const formSubmit = async () => {
      if (
        props.api?.connection_id === "1" &&
        props.api?.endpoint_id === "1" &&
        (parameters.value.username === "" ||
          parameters.value.password === "" ||
          alias_name.value === "" ||
          parameters.value.processor_id === "")
      ) {
        return;
      }

      // eslint-disable-next-line
      submitButton.value!.disabled = true;
      // Activate indicator
      submitButton.value?.setAttribute("data-kt-indicator", "on");

      // eslint-disable-next-line
      const payload: any = {
        parameters: parameters.value,
        alias_name: alias_name.value,
      };

      try {
        const res = await ApiService.put(
          `apis/merchants/${props.api?.id}`,
          payload
        );
        if (res.data.success) {
          Swal.fire({
            text: "Api Successfully updated!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          }).then(function () {
            DrawerComponent?.getInstance("update_api_drawer")?.hide();
            emit("submit");
          });
        } else {
          Swal.fire({
            text: res.data.error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } catch (e) {
        Swal.fire({
          text: e.response.data.error
            ? e.response.data.error.message
            : "Something went wrong!",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }

      submitButton.value?.removeAttribute("data-kt-indicator");
      // eslint-disable-next-line
      submitButton.value!.disabled = false;
    };

    const getProcsButton = ref<HTMLButtonElement | null>(null);

    const getProcs = async (username, password) => {
      if (username === "" || password === "") {
        return;
      }

      // eslint-disable-next-line
      getProcsButton.value!.disabled = true;
      // Activate indicator
      getProcsButton.value?.setAttribute("data-kt-indicator", "on");

      try {
        const res = await ApiService.get(
          `apis/merchants?action=nmi_processor&username=${username}&password=${password}`
        );
        if (res.data.success) {
          procsData.value = res.data.data[0];
          if (procsData.value.length === 0 || procsData.value[0] === null) {
            isShowWarning.value = true;
          } else {
            isShowWarning.value = false;
          }
        } else {
          procsData.value = [];
          isShowWarning.value = true;
        }
      } catch (e) {
        procsData.value = [];
        isShowWarning.value = true;
      }

      getProcsButton.value?.removeAttribute("data-kt-indicator");
      // eslint-disable-next-line
      getProcsButton.value!.disabled = false;
    };

    return {
      parameters,
      alias_name,
      submitButton,
      formSubmit,
      procsData,
      getProcs,
      getProcsButton,
      isShowWarning,
    };
  },
});
